import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import 'boxicons/css/boxicons.min.css'
import "@fontsource/poppins"; 
import VueKonva from 'vue-konva';
import * as Sentry from "@sentry/vue";

Vue.use(VueKonva);

Vue.use(Vuesax, {
  // options here
  colors: {
    primary: '#b648f6'
  }
})
Vue.use(VueRouter)

const routes = [
  { 
    name: 'feed',
    path: '/feed',
    component: () => import('./pages/Feed.vue'),
    meta: { loggedIn: true, isAdmin: false }
  },

  { 
    name: 'store',
    path: '/store/:productId/:orderDraftId?',
    component: () => import('./pages/Store.vue'),
    meta: { loggedIn: true, isAdmin: false },
    props: true
  },

  { 
    name: 'preview',
    path: '/preview/:orderId',
    component: () => import('./pages/Preview.vue'),
    meta: { loggedIn: true, isAdmin: false },
    props: true
  },

  { 
    name: 'user',
    path: '/user/:tab',
    component: () => import('./pages/User.vue'),
    meta: { loggedIn: true, isAdmin: false },
    props: true
  },

  { 
    name: 'checkout',
    path: '/checkout',
    component: () => import('./pages/Checkout.vue'),
    meta: { loggedIn: true, isAdmin: false },
    props: true
  },

  { 
    name: 'admin',
    path: '/admin',
    component: () => import('./pages/Admin.vue'),
    meta: { loggedIn: true, isAdmin: true }
  },

  { 
    name: 'homepage',
    path: '/',
    component: () => import('./pages/Homepage.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'faq',
    path: '/faq',
    component: () => import('./pages/FAQ.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'about',
    path: '/about',
    component: () => import('./pages/About.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'tos',
    path: '/tos',
    component: () => import('./pages/TOS.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'cookie-policy',
    path: '/cookie-policy',
    component: () => import('./pages/CookiePolicy.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'privacy-policy',
    path: '/privacy-policy',
    component: () => import('./pages/PrivacyPolicy.vue'),
    meta: { loggedIn: false, isAdmin: false }
  },

  { 
    name: 'afterCheckout',
    path: '/checkout/done',
    component: () => import('./pages/AfterCheckout.vue'),
    meta: { loggedIn: true, isAdmin: false },
    props: true

  },

  {
    name: 'ssr',
    path: '/cgi-bin/ssr',
    component: () => import('./pages/SSR.vue'),
    meta: { loggedIn: false, isAdmin: false }
    
  },

  {
    name: 'drafts',
    path: '/drafts',
    component: () => import('./pages/Drafts.vue'),
    meta: { loggedIn: true, isAdmin: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

Sentry.init({
  Vue,
  dsn: "https://9bde14d1d2606dfe0534846af9d73f32@sentry.wised.it/5",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [window.location.origin],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

window.addEventListener("load", function() { // Inizializzo vue solo dopo che il caricamento della pagina è completo (tutti gli altri assets js caricati)
  new Vue({
    router: router,
    el: '#app',
    render: h => h(App)
  })
});
